import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { useHistory } from 'react-router-dom';
import { getRoundReportStorageItem, updateRoundReportStorageItem } from 'actions/admin/roundReportStorageItems';
import { createStorageNote } from 'actions/admin/storages';
import { handleResponse } from 'actions/actionHelpers';
import routes from 'routes';

import Loader from 'common/Loader';
import AdminPage from '../../presentational/AdminPage';
import AdminContentWrapper from '../../presentational/AdminContentWrapper';
import AdminActionWrapper from '../../presentational/AdminActionWrapper';
import Button from '@material-ui/core/Button';
import EditNoteDialog from 'components/EditNoteDialog';
import EditRoundReportStorageItemForm from './EditRoundReportStorageItemForm';

const RoundReportStorageItem = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const params = useParams();

    const [roundReportStorageItem, setRoundReportStorageItem] = useState(undefined);
    const [isLoading, setIsLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [noteDialogOpen, setNoteDialogOpen] = useState(false);
    const { roundReportStorageItemId } = params;

    useEffect(() => {
        loadRoundReportStorageItem();
    }, [roundReportStorageItemId]);

    const loadRoundReportStorageItem = () => {
        setIsLoading(true);
        dispatch(getRoundReportStorageItem(roundReportStorageItemId))
            .then(handleResponse(
                response => {
                    setRoundReportStorageItem(response.payload);
                    setIsLoading(false);
                },
                () => setIsLoading(false)
            ));
    };

    const handleSubmit = formValues => {
        setIsSubmitting(true);
        dispatch(updateRoundReportStorageItem(roundReportStorageItemId, formValues))
            .then(handleResponse(
                () => {
                    history.push(routes.admin.roundReportStorageItems);
                    setIsSubmitting(false);
                    return { snackbar: { message: 'Round report storage item was successfully saved.' } };
                },
                () => setIsSubmitting(false)
            ));
    };

    const handleCancel = () => {
        history.push(routes.admin.roundReportStorageItems);
    };

    const handleAddNoteClick = () => {
        setNoteDialogOpen(true);
    };

    const handleNoteDialogSubmit = (formValues, form) => {
        setIsLoading(true);
        setNoteDialogOpen(false);
        const request = {
            text: formValues.text
        };
        dispatch(createStorageNote(roundReportStorageItem.storageId, request))
            .then(handleResponse(
                response => {
                    const newRoundReportStorageItem = { ...roundReportStorageItem };
                    newRoundReportStorageItem.notes.push(response.payload);
                    setRoundReportStorageItem(newRoundReportStorageItem);
                    form.reset();
                    setIsLoading(false);
                    return { snackbar: { message: 'Note was successfully saved.' } };
                },
                () => {
                    setIsLoading(false);
                }
            ));
    };

    const handleNoteDialogCancel = () => {
        setNoteDialogOpen(false);
    };

    const title = 'Round report storage item: ' + (roundReportStorageItem ? `${roundReportStorageItem.storageSiteTitle}, ${roundReportStorageItem.storageTitle}` : 'Loading...');

    return (
        <AdminPage title={title}>
            {
                isLoading && <Loader />
            }
            {
                !isLoading && roundReportStorageItem && (
                    <AdminContentWrapper type="detail">

                        <EditRoundReportStorageItemForm
                            roundReportStorageItem={roundReportStorageItem}
                            onSubmit={handleSubmit}
                            onCancel={handleCancel}
                            isSubmitting={isSubmitting}
                        />

                        <AdminActionWrapper>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleAddNoteClick}
                            >
                                Add note
                            </Button>
                        </AdminActionWrapper>

                    </AdminContentWrapper>
                )
            }
            <EditNoteDialog
                open={noteDialogOpen}
                onSubmit={handleNoteDialogSubmit}
                onCancel={handleNoteDialogCancel}
            />
        </AdminPage>
    );
};

export default RoundReportStorageItem;
